import { Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import * as ActionsList from './actions';
import { map, switchMap } from 'rxjs/operators';
import { Store } from '@ngrx/store';
import { WebUserService } from 'src/app/services/webuser.service';
import { Router } from '@angular/router';

@Injectable()
export class ForgotPasswordEffects {
  constructor(private store: Store<any>,
    private router: Router,
    private actions$: Actions,
    private service: WebUserService) {
  }

  submit$ = createEffect(() => this.actions$.pipe(
    ofType(ActionsList.SubmitRequestAction),
    switchMap((action: any) => this.service.forgotpassword(action.payload)),
    map((data: any) => {
      this.router.navigate(['login']);

      this.service.showOk(data.message);
      return ActionsList.SubmitResponseAction();
    })
  ));

}
